import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { PlaybackService } from '@splixer/player';
import { faPlay } from '@fortawesome/pro-regular-svg-icons/faPlay';
import { NgClass, NgStyle } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Pv2ContentMenuItem } from '../../../models';

@Component({
  selector: 'pv2-button-menu-item',
  templateUrl: 'button-menu-item.component.html',
  styleUrl: 'button-grid-menu.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, NgClass, FaIconComponent, RouterLink],
})
export class Pv2ButtonMenuItemComponent {
  public readonly item = input.required<Pv2ContentMenuItem>();
  public readonly eventSource = input.required<string>();
  public readonly nameOnBottom = input(false, { transform: booleanAttribute });
  public readonly showTitleOnTop = input(false, {
    transform: booleanAttribute,
  });
  public readonly showTagLine = input(true, { transform: booleanAttribute });

  protected readonly faPlay = faPlay;
  protected router = inject(Router);
  protected playbackService = inject(PlaybackService);
  protected isPlaying = false;

  protected buttonStyles = computed(() => {
    const item = this.item();
    if (item) {
      if (item.backgroundImage) {
        return {
          'background-image': "url('" + item.backgroundImage + "')",
          'background-position': 'center',
          'background-repeat': 'no-repeat',
          'background-size': 'cover',
        };
      }
    }
    return undefined;
  });

  protected buttonClasses = computed(() => {
    const item = this.item();
    if (item.styleClass || this.isPlaying) {
      let classes = item.styleClass ?? '';
      if (this.isPlaying) {
        classes += ' playing';
      }
      return classes;
    }
    return undefined;
  });

  protected clickEvent = (event: Event) => {
    if (event) {
      event.preventDefault();
    }
    const item = this.item();
    if (item) {
      if (item.routerLink) {
        let link: string[];
        if (typeof item.routerLink === 'string') {
          link = [item.routerLink];
        } else {
          link = item.routerLink;
        }
        this.router.navigate(link);
      }
    }
  };

  protected playEvent = (event: Event) => {
    if (event) {
      event.preventDefault();
    }
    const item = this.item();
    if (item && item.playable && item.contentId) {
      this.playbackService
        .playMix(item.contentId, this.eventSource())
        .subscribe((res) => {
          if (res) {
            this.isPlaying = true;
          }
        });
    }
  };
}
